import React, { useState, useEffect } from 'react';
import './admin.css';
import logo_v1 from '../../assets/logo_vetor_v1.png';
import logo_all_white from '../../assets/logo_vetor_v1_all_white.png';
import { API_BASE_URL } from '../../global';
import Icon from '@mdi/react';
import {
  mdiChartLine,
  mdiAccountGroup,
  mdiFileDocumentOutline,
  mdiLockOpenOutline,
  mdiMapMarker,
  mdiClockOutline,
  mdiDeleteOutline,
  mdiMagnify,
  mdiLogout,
  mdiLock,
  mdiEmailOutline,
  mdiKeyOutline,
  mdiTrendingUp,
  mdiAlertCircleOutline,
  mdiChevronLeft,
  mdiChevronRight
} from '@mdi/js';

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  BarChart,
  Bar
} from 'recharts';

// MOCK DATA GENERATORS
const mockAcessos7d = [
  { data: '21/08', acessos: 1420, consultasGratuitas: 780, consultasPagas: 150 },
  { data: '22/08', acessos: 1680, consultasGratuitas: 920, consultasPagas: 190 },
  { data: '23/08', acessos: 1540, consultasGratuitas: 850, consultasPagas: 170 },
  { data: '24/08', acessos: 1890, consultasGratuitas: 1040, consultasPagas: 220 },
  { data: '25/08', acessos: 2150, consultasGratuitas: 1180, consultasPagas: 260 },
  { data: '26/08', acessos: 1980, consultasGratuitas: 1090, consultasPagas: 240 },
  { data: '27/08', acessos: 2240, consultasGratuitas: 1230, consultasPagas: 280 }
];

const mockAcessos30d = [
  { data: '29/07', acessos: 1100, consultasGratuitas: 610, consultasPagas: 120 },
  { data: '02/08', acessos: 1320, consultasGratuitas: 720, consultasPagas: 140 },
  { data: '06/08', acessos: 1250, consultasGratuitas: 690, consultasPagas: 135 },
  { data: '10/08', acessos: 1480, consultasGratuitas: 810, consultasPagas: 165 },
  { data: '14/08', acessos: 1620, consultasGratuitas: 890, consultasPagas: 180 },
  { data: '18/08', acessos: 1750, consultasGratuitas: 960, consultasPagas: 195 },
  { data: '22/08', acessos: 1980, consultasGratuitas: 1090, consultasPagas: 230 },
  { data: '27/08', acessos: 2240, consultasGratuitas: 1230, consultasPagas: 280 }
];

const mockAcessos1y = [
  { data: 'Set/25', acessos: 28400, consultasGratuitas: 15600, consultasPagas: 3100 },
  { data: 'Out/25', acessos: 31200, consultasGratuitas: 17100, consultasPagas: 3450 },
  { data: 'Nov/25', acessos: 34500, consultasGratuitas: 18900, consultasPagas: 3800 },
  { data: 'Dez/25', acessos: 29800, consultasGratuitas: 16300, consultasPagas: 3200 },
  { data: 'Jan/26', acessos: 38900, consultasGratuitas: 21300, consultasPagas: 4300 },
  { data: 'Fev/26', acessos: 41200, consultasGratuitas: 22600, consultasPagas: 4600 },
  { data: 'Mar/26', acessos: 45600, consultasGratuitas: 25000, consultasPagas: 5100 },
  { data: 'Abr/26', acessos: 48200, consultasGratuitas: 26500, consultasPagas: 5400 },
  { data: 'Mai/26', acessos: 52100, consultasGratuitas: 28600, consultasPagas: 5800 },
  { data: 'Jun/26', acessos: 56400, consultasGratuitas: 31000, consultasPagas: 6300 },
  { data: 'Jul/26', acessos: 61000, consultasGratuitas: 33500, consultasPagas: 6800 },
  { data: 'Ago/26', acessos: 65800, consultasGratuitas: 36100, consultasPagas: 7400 }
];

const mockCadastros7d = [
  { data: '21/08', cadastros: 42 },
  { data: '22/08', cadastros: 58 },
  { data: '23/08', cadastros: 49 },
  { data: '24/08', cadastros: 67 },
  { data: '25/08', cadastros: 85 },
  { data: '26/08', cadastros: 74 },
  { data: '27/08', cadastros: 92 }
];

const mockCadastros30d = [
  { data: '29/07', cadastros: 35 },
  { data: '02/08', cadastros: 48 },
  { data: '06/08', cadastros: 41 },
  { data: '10/08', cadastros: 55 },
  { data: '14/08', cadastros: 62 },
  { data: '18/08', cadastros: 70 },
  { data: '22/08', cadastros: 81 },
  { data: '27/08', cadastros: 92 }
];

const mockCadastros1y = [
  { data: 'Set/25', cadastros: 840 },
  { data: 'Out/25', cadastros: 960 },
  { data: 'Nov/25', cadastros: 1120 },
  { data: 'Dez/25', cadastros: 920 },
  { data: 'Jan/26', cadastros: 1340 },
  { data: 'Fev/26', cadastros: 1480 },
  { data: 'Mar/26', cadastros: 1650 },
  { data: 'Abr/26', cadastros: 1820 },
  { data: 'Mai/26', cadastros: 2010 },
  { data: 'Jun/26', cadastros: 2240 },
  { data: 'Jul/26', cadastros: 2480 },
  { data: 'Ago/26', cadastros: 2750 }
];

const initialUsers = Array.from({ length: 48 }, (_, i) => ({
  id: i + 1,
  nome: [
    'Carlos Rodrigues', 'Amanda Silva', 'Lucas Pereira', 'Juliana Costa', 'Fernando Santos',
    'Beatriz Oliveira', 'Gabriel Souza', 'Mariana Lima', 'Rodrigo Alves', 'Camila Rocha',
    'Felipe Barbosa', 'Larissa Martins', 'Thiago Ribeiro', 'Patricia Gomez', 'Vinicius Carvalho',
    'Fernanda Castro', 'Diego Melo', 'Aline Ferreira', 'Gustavo Henrique', 'Natalia Duarte'
  ][i % 20] + ` ${Math.floor(i / 20) + 1}`,
  email: `usuario${i + 1}@email.com.br`,
  dataCadastro: `2026-0${(i % 8) + 1}-${10 + (i % 18)}`
}));

const mockCepsRanking = [
  { cep: '01310-100', local: 'Av. Paulista - Bela Vista, São Paulo/SP', buscas: 1240, percentual: 100 },
  { cep: '04538-132', local: 'Rua Funchal - Itaim Bibi, São Paulo/SP', buscas: 980, percentual: 79 },
  { cep: '05407-002', local: 'Rua Teodoro Sampaio - Pinheiros, São Paulo/SP', buscas: 850, percentual: 68 },
  { cep: '01415-000', local: 'Rua Bela Cintra - Consolação, São Paulo/SP', buscas: 720, percentual: 58 },
  { cep: '04001-001', local: 'Rua Vergueiro - Vila Mariana, São Paulo/SP', buscas: 640, percentual: 51 },
  { cep: '03101-000', local: 'Rua da Mooca - Mooca, São Paulo/SP', buscas: 510, percentual: 41 }
];

const mockTempoDailyAverage = [
  { dia: '21/08', Home: 1.8, RelatorioGratuito: 3.2, RelatorioPago: 7.5 },
  { dia: '22/08', Home: 2.1, RelatorioGratuito: 3.5, RelatorioPago: 8.1 },
  { dia: '23/08', Home: 1.9, RelatorioGratuito: 3.0, RelatorioPago: 7.8 },
  { dia: '24/08', Home: 2.4, RelatorioGratuito: 4.1, RelatorioPago: 8.9 },
  { dia: '25/08', Home: 2.2, RelatorioGratuito: 3.8, RelatorioPago: 9.4 },
  { dia: '26/08', Home: 2.0, RelatorioGratuito: 3.6, RelatorioPago: 8.7 },
  { dia: '27/08', Home: 2.5, RelatorioGratuito: 4.3, RelatorioPago: 9.8 }
];

const mockSessaoTempos = [
  { id: 'sess_9f82a1', pagina: 'Home - Tempo na Página', duracao: '2m 15s', segundos: 135, data: '27/08/2026 20:42' },
  { id: 'sess_3a19b4', pagina: 'Relatório Gratuito', duracao: '4m 30s', segundos: 270, data: '27/08/2026 20:38' },
  { id: 'sess_7c44d2', pagina: 'Relatório Pago (Desbloqueado)', duracao: '11m 45s', segundos: 705, data: '27/08/2026 20:25' },
  { id: 'sess_1e99f0', pagina: 'Home - Tempo na Página', duracao: '1m 50s', segundos: 110, data: '27/08/2026 20:10' },
  { id: 'sess_5b22c8', pagina: 'Relatório Gratuito', duracao: '3m 12s', segundos: 192, data: '27/08/2026 19:55' },
  { id: 'sess_8d77e3', pagina: 'Relatório Pago (Desbloqueado)', duracao: '8m 20s', segundos: 500, data: '27/08/2026 19:40' },
  { id: 'sess_4f33a9', pagina: 'Home - Tempo na Página', duracao: '3m 05s', segundos: 185, data: '27/08/2026 19:15' }
];

const generateZeroed7d = () => {
  const result = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    result.push({ data: `${day}/${month}`, acessos: 0, consultasGratuitas: 0, consultasPagas: 0, cadastros: 0 });
  }
  return result;
};

const generateZeroed30d = () => {
  const result = [];
  for (let i = 29; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    result.push({ data: `${day}/${month}`, acessos: 0, consultasGratuitas: 0, consultasPagas: 0, cadastros: 0 });
  }
  return result;
};

const generateZeroed1y = () => {
  const result = [];
  const mesesNome = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
  for (let i = 11; i >= 0; i--) {
    const d = new Date();
    d.setMonth(d.getMonth() - i);
    const mStr = mesesNome[d.getMonth()];
    const yStr = String(d.getFullYear()).slice(-2);
    result.push({ data: `${mStr}/${yStr}`, acessos: 0, consultasGratuitas: 0, consultasPagas: 0, cadastros: 0 });
  }
  return result;
};

const generateZeroedTempoDailyAverage = () => {
  const result = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    result.push({ dia: `${day}/${month}`, Home: 0, RelatorioGratuito: 0, RelatorioPago: 0 });
  }
  return result;
};

export default function Admin() {
  // AUTHENTICATION STATE
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('admin_authenticated') === 'true';
  });
  const [adminEmail, setAdminEmail] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [senhaInput, setSenhaInput] = useState('');
  const [loginError, setLoginError] = useState('');

  // ACTIVE TAB STATE
  const [activeTab, setActiveTab] = useState('overview');

  // CHART PERIOD FILTER (7d, 30d, 1y)
  const [chartPeriod, setChartPeriod] = useState('7d');
  const [userChartPeriod, setUserChartPeriod] = useState('7d');
  const [timePageFilter, setTimePageFilter] = useState('todas');

  // USER MANAGEMENT STATE
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [userToDelete, setUserToDelete] = useState(null);
  const USERS_PER_PAGE = 20;

  // VERIFY BACKEND SESSION ON MOUNT
  useEffect(() => {
    fetch(`${API_BASE_URL}/admin/check-auth.php`, { credentials: 'include' })
      .then((res) => {
        if (!res.ok) throw new Error('Sessão não autenticada');
        return res.json();
      })
      .then((data) => {
        if (data && data.authenticated) {
          sessionStorage.setItem('admin_authenticated', 'true');
          setIsAuthenticated(true);
          if (data.email) setAdminEmail(data.email);
        } else {
          sessionStorage.removeItem('admin_authenticated');
          setIsAuthenticated(false);
          setAdminEmail('');
        }
      })
      .catch(() => {
        sessionStorage.removeItem('admin_authenticated');
        setIsAuthenticated(false);
        setAdminEmail('');
      });
  }, []);

  // LOGIN SUBMIT HANDLER VIA SERVER-SIDE PHP
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    try {
      const res = await fetch(`${API_BASE_URL}/admin/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: emailInput.trim(), senha: senhaInput })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        sessionStorage.setItem('admin_authenticated', 'true');
        setIsAuthenticated(true);
        if (data.email) setAdminEmail(data.email);
        setSenhaInput('');
      } else {
        sessionStorage.removeItem('admin_authenticated');
        setIsAuthenticated(false);
        setLoginError(data.error || 'E-mail ou senha incorretos. Verifique suas credenciais.');
      }
    } catch (err) {
      sessionStorage.removeItem('admin_authenticated');
      setIsAuthenticated(false);
      setLoginError('Erro de conexão ao autenticar no servidor.');
    }
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE_URL}/admin/logout.php`, {
        method: 'POST',
        credentials: 'include'
      });
    } catch (e) {}
    sessionStorage.removeItem('admin_authenticated');
    setIsAuthenticated(false);
    setAdminEmail('');
  };

  // DASHBOARD DYNAMIC STATS STATE
  const [statsData, setStatsData] = useState({
    totalAcessos: 0,
    consultasGratuitas: 0,
    consultasPagas: 0,
    desbloqueiosPagos: 0,
    proporcaoGratuitas: '0.0',
    tempoMedioFormatado: '0m 0s',
    cepsRanking: [],
    sessaoTempos: [],
    acessos7d: [],
    acessos30d: [],
    acessos1y: []
  });

  const [dbUsers, setDbUsers] = useState(null);
  const [totalDbUsers, setTotalDbUsers] = useState(null);
  const [userStatsData, setUserStatsData] = useState({
    cadastros7d: [],
    cadastros30d: [],
    cadastros1y: []
  });

  // FETCH DASHBOARD STATS FROM PHP BACKEND
  useEffect(() => {
    if (!isAuthenticated) return;
    fetch(`${API_BASE_URL}/admin/dashboard-stats.php?page_filter=${timePageFilter}`)
      .then((res) => res.json())
      .then((data) => {
        if (data && !data.error) {
          setStatsData((prev) => ({ ...prev, ...data }));
        }
      })
      .catch((err) => console.warn('Erro ao carregar estatísticas:', err));
  }, [isAuthenticated, timePageFilter]);

  const fetchUsers = () => {
    if (!isAuthenticated) return;
    fetch(`${API_BASE_URL}/admin/users.php?page=${currentPage}&search=${encodeURIComponent(searchTerm)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          if (data.users) setDbUsers(data.users);
          if (data.totalUsers !== undefined) setTotalDbUsers(data.totalUsers);
          if (data.cadastros7d) {
            setUserStatsData({
              cadastros7d: data.cadastros7d,
              cadastros30d: data.cadastros30d,
              cadastros1y: data.cadastros1y
            });
          }
        }
      })
      .catch((err) => console.warn('Erro ao carregar usuários:', err));
  };

  // FETCH USERS FROM PHP BACKEND
  useEffect(() => {
    fetchUsers();
  }, [isAuthenticated, currentPage, searchTerm]);

  // DELETE USER HANDLER (LOCAL & BACKEND)
  const confirmDeleteUser = async () => {
    if (userToDelete) {
      const targetId = userToDelete.id;
      const targetEmail = userToDelete.email;
      setUserToDelete(null);

      // Atualização otimista no estado local
      setDbUsers((prev) => (prev ? prev.filter((u) => u.id !== targetId && u.email !== targetEmail) : []));
      setTotalDbUsers((prev) => Math.max((prev || 1) - 1, 0));

      try {
        await fetch(`${API_BASE_URL}/admin/users.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'delete', id: targetId, email: targetEmail })
        });
        fetchUsers();
      } catch (e) {
        console.warn('Erro na deleção no backend:', e);
      }
    }
  };

  // PAGINATION CALCULATIONS
  const startIndex = (currentPage - 1) * USERS_PER_PAGE;
  const activeUsersList = dbUsers !== null ? dbUsers : [];
  const activeTotalUsers = totalDbUsers !== null ? totalDbUsers : 0;
  const activeTotalPages = Math.ceil(activeTotalUsers / USERS_PER_PAGE) || 1;

  // CHART DATA BASED ON PERIOD
  const getChartData = () => {
    if (chartPeriod === '30d') {
      return (statsData.acessos30d && statsData.acessos30d.length > 0) ? statsData.acessos30d : generateZeroed30d();
    }
    if (chartPeriod === '1y') {
      return (statsData.acessos1y && statsData.acessos1y.length > 0) ? statsData.acessos1y : generateZeroed1y();
    }
    return (statsData.acessos7d && statsData.acessos7d.length > 0) ? statsData.acessos7d : generateZeroed7d();
  };

  const getUserChartData = () => {
    if (userChartPeriod === '30d') {
      return (userStatsData.cadastros30d && userStatsData.cadastros30d.length > 0) ? userStatsData.cadastros30d : generateZeroed30d();
    }
    if (userChartPeriod === '1y') {
      return (userStatsData.cadastros1y && userStatsData.cadastros1y.length > 0) ? userStatsData.cadastros1y : generateZeroed1y();
    }
    return (userStatsData.cadastros7d && userStatsData.cadastros7d.length > 0) ? userStatsData.cadastros7d : generateZeroed7d();
  };

  const getTempoDailyAverageData = () => {
    return (statsData.tempoDailyAverage && statsData.tempoDailyAverage.length > 0)
      ? statsData.tempoDailyAverage
      : generateZeroedTempoDailyAverage();
  };

  // METRIC CALCULATIONS FROM STATE
  const totalAcessos = statsData.totalAcessos ?? 0;
  const consultasGratuitas = statsData.consultasGratuitas ?? 0;
  const consultasPagas = statsData.consultasPagas ?? 0;
  const desbloqueiosPagos = statsData.desbloqueiosPagos ?? 0;
  const proporcaoGratuitas = statsData.proporcaoGratuitas ?? '0.0';
  const tempoMedioFormatado = statsData.tempoMedioFormatado || '0m 0s';
  const cepsRanking = statsData.cepsRanking || [];
  const sessaoTempos = statsData.sessaoTempos || [];

  // RENDER LOGIN SCREEN IF NOT AUTHENTICATED
  if (!isAuthenticated) {
    return (
      <div className="admin-login-wrapper">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <img src={logo_all_white} alt="Me LocalizaÊ Logo" />
            <h2>Painel Administrativo</h2>
            <p>Insira suas credenciais de acesso para continuar</p>
          </div>

          <form className="admin-login-form" onSubmit={handleLogin}>
            {loginError && (
              <div className="admin-error-box">
                <Icon path={mdiAlertCircleOutline} size={0.8} />
                <span>{loginError}</span>
              </div>
            )}

            <div className="admin-input-group">
              <label>E-mail administrativo</label>
              <div className="admin-input-wrapper">
                <Icon path={mdiEmailOutline} size={0.8} className="admin-input-icon" />
                <input
                  type="email"
                  placeholder="admin@empresa.com.br"
                  value={emailInput}
                  onChange={(e) => setEmailInput(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="admin-input-group">
              <label>Senha de acesso</label>
              <div className="admin-input-wrapper">
                <Icon path={mdiKeyOutline} size={0.8} className="admin-input-icon" />
                <input
                  type="password"
                  placeholder="••••••••"
                  value={senhaInput}
                  onChange={(e) => setSenhaInput(e.target.value)}
                  required
                />
              </div>
            </div>

            <button type="submit" className="admin-btn-primary">
              <Icon path={mdiLock} size={0.8} />
              Entrar no Dashboard
            </button>
          </form>
        </div>
      </div>
    );
  }

  // MAIN DASHBOARD LAYOUT
  return (
    <div className="admin-container">
      <div className="admin-layout">
        {/* SIDEBAR */}
        <aside className="admin-sidebar">
          <div className="admin-sidebar-header">
            <img src={logo_v1} alt="Me LocalizaÊ" />
            <div className="admin-sidebar-brand">
              <h1>Me LocalizaÊ</h1>
              <span>ADMIN</span>
            </div>
          </div>

          <nav className="admin-nav">
            <button
              className={`admin-nav-item ${activeTab === 'overview' ? 'active' : ''}`}
              onClick={() => setActiveTab('overview')}
            >
              <Icon path={mdiChartLine} size={0.9} />
              <span>Visão Geral & Métricas</span>
            </button>

            <button
              className={`admin-nav-item ${activeTab === 'users' ? 'active' : ''}`}
              onClick={() => setActiveTab('users')}
            >
              <Icon path={mdiAccountGroup} size={0.9} />
              <span>Gestão de Usuários</span>
            </button>

            <button
              className={`admin-nav-item ${activeTab === 'time' ? 'active' : ''}`}
              onClick={() => setActiveTab('time')}
            >
              <Icon path={mdiClockOutline} size={0.9} />
              <span>Tempo em Página</span>
            </button>
          </nav>

          <div className="admin-sidebar-footer">
            <div className="admin-user-info">
              <span className="admin-user-name">Administrador</span>
              <span className="admin-user-role">{adminEmail || 'Sessão Ativa'}</span>
            </div>
            <button className="admin-logout-btn" onClick={handleLogout} title="Sair do Sistema">
              <Icon path={mdiLogout} size={0.8} />
            </button>
          </div>
        </aside>

        {/* MAIN CONTENT AREA */}
        <main className="admin-main-content">
          <div className="admin-top-bar">
            <div className="admin-title-area">
              <h2>Dashboard de Performance & Analytics</h2>
              <p>Métricas consolidadas de tráfego, consultas de CEP e engajamento</p>
            </div>
          </div>

          {/* KPI METRIC CARDS */}
          <div className="admin-kpi-grid">
            <div className="admin-kpi-card">
              <div className="admin-kpi-top">
                <div className="admin-kpi-icon icon-blue">
                  <Icon path={mdiChartLine} size={1} />
                </div>
                <span className="admin-kpi-badge badge-up">
                  <Icon path={mdiTrendingUp} size={0.6} /> +12.4%
                </span>
              </div>
              <p className="admin-kpi-value">{totalAcessos.toLocaleString('pt-BR')}</p>
              <p className="admin-kpi-label">Acessos Únicos Totais</p>
              <p className="admin-kpi-sub">Total acumulado recente</p>
            </div>

            <div className="admin-kpi-card">
              <div className="admin-kpi-top">
                <div className="admin-kpi-icon icon-orange">
                  <Icon path={mdiFileDocumentOutline} size={1} />
                </div>
                <span className="admin-kpi-badge badge-neutral">{proporcaoGratuitas}%</span>
              </div>
              <p className="admin-kpi-value">{consultasGratuitas.toLocaleString('pt-BR')}</p>
              <p className="admin-kpi-label">Consultas Gratuitas</p>
              <p className="admin-kpi-sub">{proporcaoGratuitas}% do total de acessos</p>
            </div>

            <div className="admin-kpi-card">
              <div className="admin-kpi-top">
                <div className="admin-kpi-icon icon-green">
                  <Icon path={mdiLockOpenOutline} size={1} />
                </div>
                <span className="admin-kpi-badge badge-up">
                  <Icon path={mdiTrendingUp} size={0.6} /> +18.2%
                </span>
              </div>
              <p className="admin-kpi-value">{desbloqueiosPagos.toLocaleString('pt-BR')}</p>
              <p className="admin-kpi-label">Desbloqueios de Relatórios Pagos</p>
              <p className="admin-kpi-sub">{consultasPagas.toLocaleString('pt-BR')} consultas pagas totais</p>
            </div>

            <div className="admin-kpi-card">
              <div className="admin-kpi-top">
                <div className="admin-kpi-icon icon-purple">
                  <Icon path={mdiClockOutline} size={1} />
                </div>
                <span className="admin-kpi-badge badge-up">
                  <Icon path={mdiTrendingUp} size={0.6} /> +8.5m
                </span>
              </div>
              <p className="admin-kpi-value">{tempoMedioFormatado}</p>
              <p className="admin-kpi-label">Média Geral em Página</p>
              <p className="admin-kpi-sub">Permanência média por sessão</p>
            </div>
          </div>

          {/* TAB 1: OVERVIEW */}
          {activeTab === 'overview' && (
            <>
              {/* UNIQUE ACCESSES LINE CHART */}
              <div className="admin-card">
                <div className="admin-card-header">
                  <div className="admin-card-title">
                    <h3>Acessos Únicos Diários / Mensais</h3>
                    <p>Evolução no número de acessos únicos ao longo do tempo</p>
                  </div>

                  <div className="admin-filter-group">
                    <button
                      className={`admin-filter-btn ${chartPeriod === '7d' ? 'active' : ''}`}
                      onClick={() => setChartPeriod('7d')}
                    >
                      Últimos 7 dias
                    </button>
                    <button
                      className={`admin-filter-btn ${chartPeriod === '30d' ? 'active' : ''}`}
                      onClick={() => setChartPeriod('30d')}
                    >
                      Últimos 30 dias
                    </button>
                    <button
                      className={`admin-filter-btn ${chartPeriod === '1y' ? 'active' : ''}`}
                      onClick={() => setChartPeriod('1y')}
                    >
                      Último 1 Ano
                    </button>
                  </div>
                </div>

                <div className="admin-chart-box">
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={getChartData()} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#233148" />
                      <XAxis dataKey="data" stroke="#94a3b8" />
                      <YAxis stroke="#94a3b8" domain={[0, (dataMax) => Math.max(dataMax, 5)]} allowDecimals={false} />
                      <Tooltip
                        contentStyle={{ backgroundColor: '#182234', borderColor: '#2a3854', borderRadius: '8px', color: '#fff' }}
                        itemStyle={{ color: '#fc7b44' }}
                      />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="acessos"
                        name="Acessos Únicos"
                        stroke="#fc7b44"
                        strokeWidth={3}
                        dot={{ r: 4, fill: '#fc7b44' }}
                        activeDot={{ r: 7 }}
                      />
                      <Line
                        type="monotone"
                        dataKey="consultasGratuitas"
                        name="Consulta relatório gratuito"
                        stroke="#3b82f6"
                        strokeWidth={2.5}
                        dot={{ r: 4, fill: '#3b82f6' }}
                        activeDot={{ r: 7 }}
                      />
                      <Line
                        type="monotone"
                        dataKey="consultasPagas"
                        name="Consulta relatório pago"
                        stroke="#10b981"
                        strokeWidth={2.5}
                        dot={{ r: 4, fill: '#10b981' }}
                        activeDot={{ r: 7 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>

              {/* CEPS MAIS PROCURADOS & RESUMO DE CONSULTAS */}
              <div className="admin-card">
                <div className="admin-card-header">
                  <div className="admin-card-title">
                    <h3>CEPs Mais Procurados na Plataforma</h3>
                    <p>Ranking das regiões com maior volume de relatórios gerados</p>
                  </div>
                </div>

                <div className="admin-ceps-grid">
                  {cepsRanking.length > 0 ? (
                    cepsRanking.map((cepItem, idx) => (
                      <div key={idx} className="admin-cep-card">
                        <div className="admin-cep-header">
                          <span className="admin-cep-number">
                            <Icon path={mdiMapMarker} size={0.7} color="#fc7b44" />
                            {cepItem.cep}
                          </span>
                          <span className="admin-cep-count">{cepItem.buscas} consultas</span>
                        </div>
                        <p className="admin-cep-location">{cepItem.local}</p>
                        <div className="admin-progress-bar-bg">
                          <div
                            className="admin-progress-bar-fill"
                            style={{ width: `${cepItem.percentual}%` }}
                          ></div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: '#94a3b8', padding: '20px', gridColumn: '1 / -1' }}>
                      Nenhum CEP pesquisado ainda no sistema.
                    </p>
                  )}
                </div>
              </div>
            </>
          )}

          {/* TAB 2: USERS PAGINATED LIST */}
          {activeTab === 'users' && (
            <>
              {/* NEW USERS LINE CHART */}
              <div className="admin-card">
                <div className="admin-card-header">
                  <div className="admin-card-title">
                    <h3>Evolução de Novos Cadastros</h3>
                    <p>Número de novos usuários cadastrados por período (diário / mensal)</p>
                  </div>

                  <div className="admin-filter-group">
                    <button
                      className={`admin-filter-btn ${userChartPeriod === '7d' ? 'active' : ''}`}
                      onClick={() => setUserChartPeriod('7d')}
                    >
                      Últimos 7 dias
                    </button>
                    <button
                      className={`admin-filter-btn ${userChartPeriod === '30d' ? 'active' : ''}`}
                      onClick={() => setUserChartPeriod('30d')}
                    >
                      Últimos 30 dias
                    </button>
                    <button
                      className={`admin-filter-btn ${userChartPeriod === '1y' ? 'active' : ''}`}
                      onClick={() => setUserChartPeriod('1y')}
                    >
                      Último 1 Ano
                    </button>
                  </div>
                </div>

                <div className="admin-chart-box">
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={getUserChartData()} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#233148" />
                      <XAxis dataKey="data" stroke="#94a3b8" />
                      <YAxis stroke="#94a3b8" domain={[0, (dataMax) => Math.max(dataMax, 5)]} allowDecimals={false} />
                      <Tooltip
                        contentStyle={{ backgroundColor: '#182234', borderColor: '#2a3854', borderRadius: '8px', color: '#fff' }}
                        itemStyle={{ color: '#8b5cf6' }}
                      />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="cadastros"
                        name="Novos Cadastros"
                        stroke="#8b5cf6"
                        strokeWidth={3}
                        dot={{ r: 4, fill: '#8b5cf6' }}
                        activeDot={{ r: 7 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>

              <div className="admin-card">
              <div className="admin-card-header">
                <div className="admin-card-title">
                  <h3>Usuários Cadastrados</h3>
                  <p>Listagem paginada (20 por página) com opções de gerenciamento</p>
                </div>
              </div>

              <div className="admin-table-controls">
                <div className="admin-search-wrapper">
                  <Icon path={mdiMagnify} size={0.8} className="admin-search-icon" />
                  <input
                    type="text"
                    placeholder="Buscar por nome ou e-mail..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>

              <div className="admin-table-wrapper">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th style={{ width: '60px' }}>#</th>
                      <th>Nome</th>
                      <th>E-mail</th>
                      <th>Data de Cadastro</th>
                      <th style={{ width: '120px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeUsersList.length > 0 ? (
                      activeUsersList.map((u) => (
                        <tr key={u.id}>
                          <td>
                            <div className="admin-user-avatar">{u.nome.charAt(0)}</div>
                          </td>
                          <td style={{ fontWeight: '600', color: '#ffffff' }}>{u.nome}</td>
                          <td style={{ color: '#94a3b8' }}>{u.email}</td>
                          <td style={{ color: '#94a3b8' }}>{u.dataCadastro}</td>
                          <td style={{ textAlign: 'center' }}>
                            <button
                              className="admin-btn-delete"
                              onClick={() => setUserToDelete(u)}
                              title="Apagar Usuário"
                            >
                              <Icon path={mdiDeleteOutline} size={0.7} />
                              Apagar
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8' }}>
                          Nenhum usuário encontrado com o termo informado.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* PAGINATION CONTROLS */}
              <div className="admin-pagination">
                <div className="admin-pagination-info">
                  Exibindo <strong>{activeUsersList.length > 0 ? startIndex + 1 : 0}</strong> a{' '}
                  <strong>{Math.min(startIndex + USERS_PER_PAGE, activeTotalUsers)}</strong> de{' '}
                  <strong>{activeTotalUsers}</strong> usuários
                </div>

                <div className="admin-pagination-btns">
                  <button
                    className="admin-page-btn"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  >
                    <Icon path={mdiChevronLeft} size={0.8} />
                  </button>

                  {Array.from({ length: activeTotalPages }, (_, i) => i + 1).map((pageNum) => (
                    <button
                      key={pageNum}
                      className={`admin-page-btn ${currentPage === pageNum ? 'active' : ''}`}
                      onClick={() => setCurrentPage(pageNum)}
                    >
                      {pageNum}
                    </button>
                  ))}

                  <button
                    className="admin-page-btn"
                    disabled={currentPage === activeTotalPages || activeTotalPages === 0}
                    onClick={() => setCurrentPage((p) => Math.min(p + 1, activeTotalPages))}
                  >
                    <Icon path={mdiChevronRight} size={0.8} />
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

          {/* TAB 3: TIME SPENT ON PAGES */}
          {activeTab === 'time' && (
            <>
              {/* AVERAGE TIME BAR CHART */}
              <div className="admin-card">
                <div className="admin-card-header">
                  <div className="admin-card-title">
                    <h3>Média Diária de Tempo em Página (Segundos)</h3>
                    <p>Comparativo diário de permanência em segundos na Página Inicial, Relatório Gratuito e Pago</p>
                  </div>
                </div>

                <div className="admin-chart-box">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={getTempoDailyAverageData()} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#233148" />
                      <XAxis dataKey="dia" stroke="#94a3b8" />
                      <YAxis stroke="#94a3b8" unit=" seg" />
                      <Tooltip
                        contentStyle={{ backgroundColor: '#182234', borderColor: '#2a3854', borderRadius: '8px', color: '#fff' }}
                        formatter={(val) => [`${val} seg`, 'Média']}
                      />
                      <Legend />
                      <Bar dataKey="Home" name="Página Inicial" fill="#3b82f6" radius={[4, 4, 0, 0]} />
                      <Bar dataKey="RelatorioGratuito" name="Relatório Gratuito" fill="#fc7b44" radius={[4, 4, 0, 0]} />
                      <Bar dataKey="RelatorioPago" name="Relatório Pago" fill="#10b981" radius={[4, 4, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>

              {/* RECENT ACCESS SESSIONS LIST */}
              <div className="admin-card">
                <div className="admin-card-header">
                  <div className="admin-card-title">
                    <h3>Listagem do Tempo Total de Acessos Recentes</h3>
                    <p>Registros individuais dos últimos 7 dias capturados pelo sistema de envio de logs (tempo por sessão)</p>
                  </div>
                  <div className="admin-filter-group">
                    <button
                      className={`admin-filter-btn ${timePageFilter === 'todas' ? 'active' : ''}`}
                      onClick={() => setTimePageFilter('todas')}
                    >
                      Todas as Páginas
                    </button>
                    <button
                      className={`admin-filter-btn ${timePageFilter === 'home' ? 'active' : ''}`}
                      onClick={() => setTimePageFilter('home')}
                    >
                      Home
                    </button>
                    <button
                      className={`admin-filter-btn ${timePageFilter === 'gratuito' ? 'active' : ''}`}
                      onClick={() => setTimePageFilter('gratuito')}
                    >
                      Relatório Gratuito
                    </button>
                    <button
                      className={`admin-filter-btn ${timePageFilter === 'pago' ? 'active' : ''}`}
                      onClick={() => setTimePageFilter('pago')}
                    >
                      Relatório Pago
                    </button>
                  </div>
                </div>

                <div className="admin-table-wrapper">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Sessão ID</th>
                        <th>Página Acessada</th>
                        <th>Tempo Total</th>
                        <th>Data e Hora</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sessaoTempos.length > 0 ? (
                        sessaoTempos.map((s) => (
                          <tr key={s.id}>
                            <td style={{ fontFamily: 'monospace', color: '#60a5fa' }}>{s.id}</td>
                            <td style={{ fontWeight: '600', color: '#ffffff' }}>{s.pagina}</td>
                            <td>
                              <span className="admin-badge-paid">{s.duracao}</span>
                            </td>
                            <td style={{ color: '#94a3b8' }}>{s.data}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" style={{ textAlign: 'center', padding: '20px', color: '#94a3b8' }}>
                            Nenhum registro de tempo de sessão capturado ainda.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {/* CONFIRM DELETE MODAL */}
          {userToDelete && (
            <div className="admin-modal-overlay">
              <div className="admin-modal-card">
                <h3>Apagar Usuário</h3>
                <p>
                  Tem certeza que deseja apagar permanentemente o usuário{' '}
                  <strong>{userToDelete.nome}</strong> ({userToDelete.email})?
                </p>
                <div className="admin-modal-actions">
                  <button className="admin-btn-cancel" onClick={() => setUserToDelete(null)}>
                    Cancelar
                  </button>
                  <button className="admin-btn-confirm-delete" onClick={confirmDeleteUser}>
                    Confirmar Exclusão
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
